jQuery.feature_import("js-draggable",
  () => require("./draggable-bs-modal.js"),
  mod => mod.feature_js_draggable
);